export default "__VITE_PUBLIC_ASSET__2f9545c9__"